import { configureStore } from '@reduxjs/toolkit'

import floorReducer from './floorSlice'
import reasonReducer from './reasonSlice'
import applicationReducer from './applicationSlice'
import userReducer from './userSlice'
import visitorReducer from './visitorSlice'

import vipHostReducer from './vipHostSlice'

import  requestReducer from './requestSlice'    

import  pagedEnquiryReducer from './pagedEnquirySlice'    

// import { apiSlice } from '../features/api/apiSlice'

export default configureStore({
  reducer: {
    floor: floorReducer,
    reason: reasonReducer,
    application :applicationReducer,
    user :userReducer,
    visitor: visitorReducer,
    request :requestReducer,
    pagedEnquiry: pagedEnquiryReducer,

    vipHost :vipHostReducer
  }
//   middleware: (getDefaultMiddleware) =>
//     getDefaultMiddleware().concat(apiSlice.middleware),
})
